import { render, staticRenderFns } from "./AddressEditCard.vue?vue&type=template&id=55c535d2&"
import script from "./AddressEditCard.vue?vue&type=script&lang=js&"
export * from "./AddressEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports